import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from '../styles.module.scss';

function ChannelTabsHeader({
  channels,
  activeChannelId,
  getBadgeCount,
  onChange,
}) {
  const handleTabClick = useCallback((channelId) => () => {
    onChange(channelId);
  }, [onChange]);

  return (
    <div className={styles.connectChannelSectionChannelTabs}>
      <div className={styles.connectChannelSectionChannelTabsList}>
        {channels.map(({ value, label }) => {
          const isActive = value === activeChannelId;
          const badgeCount = getBadgeCount(value);

          return (
            <button
              key={value}
              type="button"
              className={cn(styles.connectChannelSectionChannelTab, {
                [styles.connectChannelSectionChannelTabActive]: isActive,
              })}
              onClick={handleTabClick(value)}
            >
              <span className={cn(styles.connectChannelSectionChannelTabLabel, {
                [styles.connectChannelSectionChannelTabLabelActive]: isActive,
              })}
              >
                {label}
              </span>
              <span className={cn(styles.connectChannelSectionChannelTabBadge, {
                [styles.connectChannelSectionChannelTabBadgeActive]: isActive,
              })}
              >
                {badgeCount}
              </span>
              <If condition={isActive}>
                <span className={styles.connectChannelSectionChannelTabUnderline} />
              </If>
            </button>
          );
        })}
      </div>
      <div className={styles.connectChannelSectionChannelTabsDivider} />
    </div>
  );
}

ChannelTabsHeader.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  activeChannelId: PropTypes.string.isRequired,
  getBadgeCount: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ChannelTabsHeader;
